export default __webpack_public_path__ + "static/media/40c1689e6145318070fd.40c1689e.svg";